import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Runs a page's existing loader when the common Header refresh button is used.
export default function useHeaderRefresh(refresh) {
  const location = useLocation();
  const navigate = useNavigate();
  const refreshRef = useRef(refresh);
  refreshRef.current = refresh;

  useEffect(() => {
    if (!location.state?.refetch) return;
    refreshRef.current();
    navigate(location.pathname, { replace: true, state: {} });
  }, [location.key, location.pathname, location.state?.refetch, navigate]);
}
